module.exports = __webpack_public_path__ + "static/media/10.1de2e2ab.jpg";